import { Box, Card, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import TiltedCard from "../../../components/animation/tiltedCard/tiltedCard";
import { useCallback } from "react";

const HomeServiceBox = ({
    icon,
    title,
    description,
    to
}) => {
    const theme = useTheme();

    const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));
    const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

    const getWidth = useCallback(() => {
        if(isLgUp) return '100%';

        if(isMdUp) return '95%';

        return '95%';
    }, [isLgUp, isMdUp]);

    const getHeight = useCallback(() => {
        if(isLgUp) return '330px';

        if(isMdUp) return '255px';

        return '230px';
    }, [isLgUp, isMdUp]);

    return (
        <>
            <Link
                to={to}
                style={{
                    textDecoration: 'none'
                }}
            >
                <TiltedCard
                    containerHeight="100%"
                    containerWidth="100%"
                    imageHeight={getHeight()}
                    imageWidth={getWidth()}
                    rotateAmplitude={5}
                    scaleOnHover={0.95}
                    displayOverlayContent={true}
                    overlayContent={
                        <Card
                            elevation={3}
                            sx={{
                                width: '100%',
                                backgroundColor: theme.palette.background.default,
                                borderRadius: 8,
                                minHeight: {xs: 225, md: 250, lg: 325}
                            }}
                        >
                            <Stack
                                direction='column'
                                justifyContent='center'
                                alignItems='start'
                                p={{xs: 3, md: 5}}
                            >
                                <Box
                                    sx={{
                                        width: {xs: 35, md: 50},
                                        pb: {xs: 1, md: 3}
                                    }}
                                >
                                    <img 
                                        src={icon}
                                        alt={title} 
                                        width='100%'
                                    />
                                </Box>

                                <Typography
                                    fontWeight={600}
                                    fontSize={{xs: 12, md: 16, lg: 24}}
                                    textAlign='left'
                                    color={theme.palette.text.primary}
                                    lineHeight={1.5}
                                    pb={1}
                                >
                                    {title}
                                </Typography>

                                <Typography
                                    fontWeight={500}
                                    fontSize={{xs: 12, md: 12, lg: 14}}
                                    textAlign="left"
                                    lineHeight={1.5}
                                    color={theme.palette.text.secondary}
                                >
                                    {description}
                                </Typography>
                            </Stack>
                        </Card>
                    }
                />
            </Link>
        </>
    );
}

export default HomeServiceBox;

